export default ['$rootScope', '$timeout', 'afterNextClickService', hyperlink]

function hyperlink($rootScope, $timeout, afterNextClickService) {
  const urlWithSchemeRegex = /^(mailto:|https?:\/{2}|\/{2})(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
  const urlWithoutSchemeRegex = /^[-a-zA-Z0-9@:%_+.~#?&=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$/gi

  const isValidUrlWithScheme = (url) => {
    return new RegExp(urlWithSchemeRegex).test(url)
  }

  const isValidUrlWithoutScheme = (url) => {
    return new RegExp(urlWithoutSchemeRegex).test(url)
  }

  this.getValidUrl = (url) => {
    if (isValidUrlWithScheme(url)) {
      return url
    } else if (isValidUrlWithoutScheme(url)) {
      return '//' + url
    }

    return null
  }

  this.getSelectedLinkWithoutTrailingSlash = (linkBeingEdited) => {
    let hrefWithoutEndingSlash = linkBeingEdited
    if (linkBeingEdited[linkBeingEdited.length - 1] === '/') {
      hrefWithoutEndingSlash = linkBeingEdited.substring(
        0,
        linkBeingEdited.length - 1
      )
    }
    return hrefWithoutEndingSlash
  }

  this.initStoryLinkPopovers = (selector, editLinkPopoverTmpl) => {
    $(selector)
      .popover({
        animation: false,
        content: editLinkPopoverTmpl,
        template:
          '<div class="popover popover-link popover--dark"><div class="arrow"></div><div class="popover-content"></div></div>',
        container: 'body',
        html: true,
        placement: (context, source) => {
          var position = $(source).position()

          return position.left < 175 ? 'right' : 'bottom'
        },
        trigger: 'manual',
      })
      .on('show.bs.popover', function (linkEvent) {
        //  ML - adding a "selected-link" marker to indicate the <a> that is currently being edited ... I did not have success attempting to store the DOM element (evt.target/linkBeingEdited) within $scope
        // $element.find('#story-wrapper a.selected-link')
        //   .removeClass('selected-link')
        $('#story-wrapper .selected-link').removeClass('selected-link')
        $(linkEvent.target).closest('a').addClass('selected-link')
      })
  }

  this.openInNewTab = (linkBeingEdited) => {
    window.open(linkBeingEdited, '_blank')
  }

  this.removeLink = (selectedLink) => {
    var range = document.createRange()
    range.selectNodeContents(selectedLink)
    var sel = window.getSelection()
    sel.removeAllRanges()
    sel.addRange(range)
    document.execCommand('unlink')
  }

  const hasSelectedLink = (elem, linkElementBeingEdited) => {
    return (
      elem.content.indexOf(linkElementBeingEdited.attr('aria-describedby')) >
        -1 || elem.content.indexOf('selected-link') > -1
    )
  }

  this.getContentElementContainingLink = (story, linkElementBeingEdited) => {
    let listItemWithLink

    const elemWithLink = story.content_elements.find((e) => {
      if (e.type === 'list') {
        listItemWithLink = e.items.find((listItem) => {
          return hasSelectedLink(listItem, linkElementBeingEdited)
        })

        //  don't return the content_element if the content_element is a list that contains items, one of which contains the link
        if (listItemWithLink) {
          return false
        }
      }

      if (!e.content) {
        return false
      }

      return hasSelectedLink(e, linkElementBeingEdited)
    })

    return elemWithLink || listItemWithLink
  }
}
